import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment'; // import CommentDrawer from './CommentDrawer.vue'

import IwsUpload from '@comp/upload/IwsUpload';
import SelectSiteListModal from '@/views/assets/SelectSiteListModal';
import SelectPipeListModal from '@/views/assets/SelectPipeListModal';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'FeedBackModal',
  mixins: [ModalFormMixin],
  components: {
    // CommentDrawer,
    IwsUpload: IwsUpload,
    SelectSiteListModal: SelectSiteListModal,
    SelectPipeListModal: SelectPipeListModal
  },
  data: function data() {
    return {
      showCheck: false,
      title: '投诉单表单',
      siteName: '',
      siteId: null,
      operationType: '',
      postData: {
        siteId: '',
        operationType: '',
        complaintsDate: '',
        tel: '',
        remark: ''
      },
      form_fields: ['siteId', 'tel', 'status', 'remark', 'userId', 'operationType', 'endTime', 'completionTime'],
      form_fields_time: ['complaintsDate', 'endTime', 'completionTime'],
      userTree: [],
      validatorRules: {
        operationType: {
          rules: [{
            required: true,
            message: '请选择设施类型!'
          }]
        },
        remark: {
          rules: [{
            required: true,
            message: '请输入问题和意见!'
          }]
        },
        complaintsDate: {
          rules: [{
            required: true,
            message: '请选择投诉日期!'
          }]
        },
        endTime: {
          rules: [{
            required: true,
            message: '请选择截止时间!'
          }]
        },
        completionTime: {
          rules: [{
            required: true,
            message: '请选择完成时间!'
          }]
        },
        siteId: {
          rules: [{
            required: true,
            message: '请选择!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择处理人!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.queryUserTreeList();
  },
  methods: {
    changeUpload: function changeUpload(value) {
      console.log('value', value);
      value.sysFileList.forEach(function (item, index) {
        item['fileSrc'] = 'om_complaints_back_up';
      });
      value.fileDelList.forEach(function (item, index) {
        item['fileSrc'] = 'om_complaints_back_up';
      });
    },
    changeDownUpload: function changeDownUpload(value) {
      console.log('value', value);
      value.sysFileList.forEach(function (item, index) {
        item['fileSrc'] = 'om_complaints_back_down';
      });
      value.fileDelList.forEach(function (item, index) {
        item['fileSrc'] = 'om_complaints_back_down';
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    operationTypeChange: function operationTypeChange(value) {
      this.$set(this.model, 'operationType', value);
      this.$set(this.model, 'siteId', '');
      this.$set(this.model, 'siteName', '');
      this.$forceUpdate();
    },
    selectSite: function selectSite() {
      this.$refs.SiteListModal.add('', this.model.siteId);
    },
    selectPipe: function selectPipe() {
      this.$refs.PipeListModal.add('', this.model.siteId);
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      console.log(siteList);

      if (siteList) {
        if (siteList.length > 0) {
          this.model.siteId = siteList[0].id;
          this.model.siteName = siteList[0].name;
        }
      }

      this.$forceUpdate();
      console.log(this.model); // this.selectedSite = []
      // this.siteIds = ''
      // for (var i = 0; i < siteList.length; i++) {
      // 	this.selectedSite.push(siteList[i].name)
      // 	this.siteIds = siteList[i].id
      // 	if (this.showType == 1) {
      // 		console.log(this.index)
      // 		this.selectedSiteList[this.index].push(siteList[i].name)
      // 		this.selectedSiteList[this.index] = this.selectedSiteList[this.index].reverse()
      // 		this.formList[this.index].siteId = siteList[i].id
      // 		this.$forceUpdate()
      // 	}
      // }
    },
    // 子modal回调
    choseSiteByPipe: function choseSiteByPipe(siteList) {
      console.log(siteList);

      if (siteList) {
        if (siteList.length > 0) {
          this.model.siteId = siteList[0].id;
          this.model.siteName = siteList[0].name;
        }
      }

      this.$forceUpdate(); // this.selectedSite = []
      // this.siteIds = ''
      // for (var i = 0; i < siteList.length; i++) {
      // 	this.selectedSite.push(siteList[i].title)
      // 	this.siteIds = siteList[i].id
      // 	if (this.showType == 1) {
      // 		console.log(this.index)
      // 		this.selectedSiteList[this.index].push(siteList[i].title)
      // 		this.selectedSiteList[this.index] = this.selectedSiteList[this.index].reverse()
      // 		this.formList[this.index].siteId = siteList[i].id
      // 		console.log(' this.formList', this.formList)
      // 		this.$forceUpdate()
      // 	}
      // }
    },
    // add() {
    // 	this.edit({
    // 	})
    // },
    edit: function edit(record) {
      var _this2 = this;

      // this.model.operationType = this.operationType
      console.log('enter', record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {} else {
        this.model.siteId = this.siteId;
        this.model.complaintsDate = new Date().toLocaleDateString();
        this.model.endTime = new Date().toLocaleDateString();
        this.model.siteName = this.siteName;
        this.model.operationType = this.operationType;
        console.log('this.model', this.model);
      } // if (this.model.id) {
      //   // this.siteName = this.model.siteName
      //   this.model.siteId = this.siteId
      // } else {
      //   this.model.complaintsDate = new Date().toLocaleDateString()
      // }

      /* this.model.siteName = this.siteName
       this.model.siteId = sessionStorage.getItem('siteId')
       this.model.operationType = sessionStorage.getItem('operationType')*/
      // this.disableSubmit = this.showCheck ? true : this.disableSubmit


      this.$forceUpdate();
      this.$nextTick(function () {
        var that = _this2;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });

        if (that.model.completionTime) {
          timeVal['completionTime'] = that.model['completionTime'] ? moment(that.model['completionTime']) : null;
        }

        that.form.setFieldsValue(timeVal); // that.$refs.iwupload.loadUploadFiles()
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.complaintsDate = formData.complaintsDate ? formData.complaintsDate.format('YYYY-MM-DD') : null;
          formData.endTime = formData.endTime ? formData.endTime.format('YYYY-MM-DD') : null; // debugger

          formData.siteId = that.model.siteId;
          formData = that.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
            formData.status = 1;
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          if (formData.completionTime) {
            formData.completionTime = formData.completionTime ? formData.completionTime.format('YYYY-MM-DD') : null;
          }

          if (that.$refs.iwBackupload) {
            var datas = that.$refs.iwBackupload.getUploadListToFromData(JSON.parse(JSON.stringify(formData)));
            console.log('datas', datas);
            formData.sysFileList = formData.sysFileList.concat(datas.sysFileList);
            formData.fileDelList = formData.fileDelList.concat(datas.fileDelList);
            console.log('datas', formData);
          }

          if (_this3.showCheck) {
            formData.status++;
          }

          console.log('formData', formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};